import { cloneDeep } from "lodash";
import { initialState } from "../initialState";
import { columnActions as actions } from "../actions";
import { createReducer, methodSwitcher } from "./utilities";

const { column } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setColumnList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.list = data;
  return newState;
};

const setCurrentColumn = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.current = data;
  return newState;
};

const actionColumn = (state, { data, id, method }) => {
  const newState = cloneDeep(state);
  methodSwitcher(newState, data, id, method);
  return newState;
};

export const columnReducer = createReducer(column, {
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.LIST]: setColumnList,
  [actions.CURRENT]: setCurrentColumn,
  [actions.CUD]: actionColumn,
});
